import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import EditScreen from '../edit-screen'
import AttendanceScreen from '../attendance-screen'
import DuplicateScreen from '../duplicate-screen'
import DetailsScreen from '../details-screen'
import EnrollmentScreen from '../enrollment-management-screen'

const ExperienceRoutes = () => {
    return (
        <React.Fragment>
            <Route exact path={`${CLIENT_ENDPOINTS.EXPERIENCE}`} component={DetailsScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.EDIT}`} component={EditScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.DUPLICATE}`} component={DuplicateScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.ATTENDANCE}`} component={AttendanceScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.EXPERIENCE}${CLIENT_ENDPOINTS.ENROLLMENT}`} component={EnrollmentScreen} />
        </React.Fragment>
    )
}

export default ExperienceRoutes